import Papa from "papaparse";

export const boxWhiskerFieldKeys = (chart = {}) => [
  chart.categoryKey || "category",
  chart.minKey || "min",
  chart.q1Key || "q1",
  chart.medianKey || "median",
  chart.q3Key || "q3",
  chart.maxKey || "max",
];

export const xyChartFieldKeys = (chart = {}) => [
  chart.categoryKey || "category",
  ...(chart.type === "multiline"
    ? (chart.series || []).map((series) => series.key).filter(Boolean)
    : [chart.valueKey || "value"]),
];

const safeFilePart = (value) => String(value || "presentation")
  .trim()
  .replace(/[^a-z0-9_-]+/gi, "-")
  .replace(/^-|-$/g, "") || "presentation";

export function downloadPresentationCsv({ rows = [], fields = [], filename }) {
  const csv = Papa.unparse({
    fields,
    data: rows.map((row) => fields.map((field) => row?.[field] ?? "")),
  }, { escapeFormulae: true });
  const url = URL.createObjectURL(new Blob([csv], { type: "text/csv;charset=utf-8" }));
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = `${safeFilePart(filename)}.csv`;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}
